import { MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS, MODULE_EXTRANET_INTERVENTIONS, MODULE_EXTRANET_INVOICES, MODULE_EXTRANET_QUOTES } from "../authorizedApps/authorizedAppsConstants";
import {
    UPDATE_LOCATION_TITLE,
    LOAD_LOCATION_TITLE,
    HIDE_MENU,
    SCROLL_CHANGE,
    SET_DEBUGGING,
    SET_TRANSPARENT_FOOTER,
    SET_IS_EXTRANET_APP,
    SET_PAGE_SIZE,
    SET_PAGE_NUMBER,
    SET_NB_TOTAL_RESULTS
} from "./contextInfosConstants";

export function loadLocationTitle() {
    return (dispatch) => {
        dispatch({
            type: LOAD_LOCATION_TITLE,
            payload: { locationTitle: "" },
        });
    };
}

export function hideMenuAction(value) {
    return {
        type: HIDE_MENU,
        hideMenu: value,
    };
}

export function setTransparentFooterAction(value) {
    return {
        type: SET_TRANSPARENT_FOOTER,
        transparentFooter: value,
    };
}

export function setIsExtranetAppAction() {
    return {
        type: SET_IS_EXTRANET_APP,
        isExtranetApp: true,
    };
}

export function scrollYChangeAction(scrollY) {
    return {
        type: SCROLL_CHANGE,
        scrollY,
    };
}

export function setDebuggingAction(debugging) {
    return {
        type: SET_DEBUGGING,
        debugging,
    };
}

export function setPageSizeAction(pageSize) {
    return {
        type: SET_PAGE_SIZE,
        pageSize,
    };
}

export function setPageNumberAction(pageNumber) {
    return {
        type: SET_PAGE_NUMBER,
        pageNumber,
    };
}

export function setNbTotalResultsAction(nbTotalResults) {
    return {
        type: SET_NB_TOTAL_RESULTS,
        nbTotalResults
    }
}

export function hideMenu(value) {
    return (dispatch) => {
        dispatch(hideMenuAction(value));
    };
}

export function scrollYChange(scrollY) {
    return (dispatch) => {
        dispatch(scrollYChangeAction(scrollY));
    };
}

export function setDebugging(debugging) {
    return (dispatch) => {
        dispatch(setDebuggingAction(debugging));
    };
}

export function setTransparentFooter(transparent) {
    return (dispatch) => {
        dispatch(setTransparentFooterAction(transparent));
    }
}

export function setIsExtranetApp() {
    return (dispatch) => {
        dispatch(setIsExtranetAppAction());
    }
}

export function updateLocationTitle(locationPath) {
    let title = "";
    switch (locationPath) {
        case "/":
            title = "Accueil";
            break;
        case "/absences":
            title = "Absences";
            break;
        case "/absences/createAbsence":
            title = "Création d'une absence";
            break;
        case "/absences/editAbsence":
            title = "Édition d'une absence";
            break;
        case "/absences/validateAbsence":
            title = "Validation d'une absence";
            break;
        case "/fluide":
            title = "Fluides";
            break;
        case "/activity":
            title = "Saisie des temps";
            break;
        case "/activity/report":
            title = "Rapport d'activité";
            break;
        case "/parameters":
            title = "Système";
            break;
        case "/carteHabilitation":
            title = "Carte d'habilitation";
            break;
        case "/componentsPark":
            title = "Parc machines";
            break;
        case "/analyseRisques":
        case "/analyseRisques/editAnalyseRisques":
        case "/analyseRisques/createAnalyseRisques":
            title = "Analyse de risques";
            break;
        case "/pps":
        case "/pps/createPps":
        case "/pps/editPps":
            title = "PPS";
            break;
        case "/interventions":
            title = "Interventions";
            break;
        case "/interventions/intervention/preview":
            title = "Aperçu avant validation";
            break;
        case "/interventions/intervention":
            title = "Intervention";
            break;
        case "/interventions/createIntervention":
            title = "Création d'intervention";
            break;
        case "/siteMonitorings":
            title = "Chantiers";
            break;
        case "/siteMonitorings/siteMonitoring":
            title = "Suivi de chantier";
            break;
        case "/affairs/affair":
            title = "";
            break;
        case "/affairs":
            title = "Contrats et affaires";
            break;
        case "/parks":
            title = "Parcs machines";
            break;
        case "/parks/park":
            title = "Parc machines";
            break;
        case "/parks/park/componentPark":
            title = "Equipement";
            break;
        case "/invoices":
            title = "Factures";
            break;
        case "/quotes":
            title = "Devis";
            break;
        case "/contactUs":
            title = "Nous contacter";
            break;
        case "/humanResources":
            title = "Ressources humaines";
            break;
        case "/humanResources/form":
            title = "Entretien";
            break;
        default:
            title = "";
            break;
    }

    return (dispatch) => {
        dispatch({
            type: UPDATE_LOCATION_TITLE,
            payload: { locationTitle: title },
        });
    };
}

export function getActiveDayNeeded(locationPathName) {
    return (
        locationPathName === "/activity" ||
        locationPathName.startsWith("/interventions")
    );
}

export function setPageNumber(pageNumber) {
    return (dispatch) => {
        dispatch(setPageNumberAction(pageNumber));
    }
}

export function setPageSize(pageSize, pageNumber) {
    return (dispatch) => {
        dispatch(setPageSizeAction(pageSize));
        dispatch(setPageNumberAction(pageNumber));
    }
}

export function setNbTotalResults(nbTotalResults, resultType, value) {
    return (dispatch) => {
        nbTotalResults[resultType] = value;
        dispatch(setNbTotalResultsAction(nbTotalResults));
    }
}

export function getDefaultTotalResults() {
    let defaultTotalResults = {};

    defaultTotalResults[MODULE_EXTRANET_INTERVENTIONS] = 0
    defaultTotalResults[MODULE_EXTRANET_QUOTES] = 0
    defaultTotalResults[MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS] = 0
    defaultTotalResults[MODULE_EXTRANET_INVOICES] = 0

    return defaultTotalResults;
}
